{
  "//vg-binding": "CONTEXT:decisions=P6.1.D-28,P6.1.D-20 | INTERFACE-STANDARDS:error-shape",
  "page": {
    "title": "Thành viên",
    "subtitle": "Những người trong công ty của bạn — vai trò, team và quyền truy cập ở cùng một nơi"
  },
  "actions": {
    "invite": "Mời thành viên",
    "promoteAdmin": "Thăng lên admin",
    "promoteAdminSuccess": "Đã thăng thành viên lên admin",
    "promoteAdminError": "Không thể thăng thành viên"
  },
  "filters": {
    "searchPlaceholder": "Tìm theo tên hoặc email...",
    "role": "Vai trò: {{value}}",
    "team": "Team: {{value}}",
    "status": "Trạng thái: {{value}}",
    "all": "Tất cả"
  },
  "col": {
    "member": "Thành viên",
    "role": "Vai trò",
    "team": "Team",
    "created": "Ngày tạo",
    "updated": "Cập nhật lúc",
    "status": "Trạng thái",
    "action": "Thao tác"
  },
  "role": {
    "Admin": "Quản trị",
    "Manager": "Quản lý",
    "Staff": "Nhân viên",
    "Viewer": "Người xem"
  },
  "status": {
    "Active": "Đang hoạt động",
    "Deactive": "Ngừng hoạt động",
    "Invited": "Đã mời"
  },
  "confirm": {
    "deactivate": {
      "title": "Ngừng hoạt động thành viên này?",
      "body": "{{name}} sẽ mất quyền truy cập ngay lập tức. Bạn có thể kích hoạt lại bất cứ lúc nào.",
      "confirm": "Ngừng hoạt động",
      "cancel": "Huỷ"
    }
  },
  "toast": {
    "inviteSent": "Đã gửi lời mời",
    "memberUpdated": "Đã cập nhật thành viên",
    "toggleActivated": "Đã kích hoạt thành viên",
    "toggleDeactivated": "Đã ngừng hoạt động thành viên",
    "toggleFailed": "Không thể cập nhật trạng thái thành viên"
  },
  "empty": {
    "noResults": "Không có thành viên nào khớp bộ lọc",
    "noTeam": {
      "title": "Bạn chưa được gán vào team nào",
      "body": "Liên hệ chủ shop để được thêm vào team trước khi bạn có thể xem đơn hàng, sản phẩm và dữ liệu bảng điều khiển."
    }
  },
  "error": {
    "loadFailed": "Không thể tải danh sách thành viên.",
    "retry": "Thử lại",
    "forbidden": {
      "title": "Từ chối truy cập",
      "body": "Bạn không có quyền quản lý thành viên. Vui lòng liên hệ chủ shop."
    }
  },
  "breadcrumb": {
    "settings": "Cài đặt",
    "members": "Thành viên"
  },
  "invite": {
    "title": "Mời thành viên",
    "subtitle": "Họ sẽ nhận được email để tham gia công ty của bạn",
    "email": "Địa chỉ email",
    "emailPlaceholder": "member@company.com",
    "fullName": "Họ và tên",
    "namePlaceholder": "Nguyễn Văn A",
    "role": "Vai trò",
    "team": "Team",
    "teamPlaceholder": "Chọn team",
    "noTeams": "Chưa có team nào",
    "monthlyBudget": "Ngân sách tháng (tuỳ chọn)",
    "perOrderLimit": "Giới hạn mỗi đơn (tuỳ chọn)",
    "send": "Gửi lời mời",
    "sending": "Đang gửi...",
    "permissionHint": {
      "admin": "Quản trị thấy tất cả team, cửa hàng và thành viên trong toàn công ty.",
      "manager": "Quản lý chỉ thấy đơn hàng, sản phẩm và bảng điều khiển của các cửa hàng thuộc {{team}}, và có thể quản lý team đó.",
      "staff": "Nhân viên chỉ thấy đơn hàng, sản phẩm và bảng điều khiển của các cửa hàng thuộc {{team}}.",
      "viewer": "Người xem có quyền chỉ đọc với các cửa hàng thuộc {{team}}."
    },
    "error": {
      "duplicate": "Email này đã là thành viên trong công ty của bạn.",
      "promoteOwnerOnly": "Chỉ chủ shop mới có thể cấp vai trò Quản trị.",
      "generic": "Không thể gửi lời mời. Vui lòng thử lại."
    }
  }
}
